export const personalAccessTokens = ({ personalAccessTokens: { tokens } }) => tokens;
export const personalAccessTokensIsFetching = state => state.personalAccessTokens.isFetching;

export const documents = state => state.documents;
export const specs = state => state.specs;
export const spec = state => state.spec;
